export default __webpack_public_path__ + "static/media/T13A.eca4f2f9.png";